export default __webpack_public_path__ + "static/media/aqua.2dc4162c.png";